import { createSlice } from "@reduxjs/toolkit";
import { State } from "store/state";
import { cloneDeep } from "lodash";
import { ExhibitorsValidationResult } from "ts/app/exhibitorsBulkUpload";
import {
  ExhibitorCsvUploadProgress,
  ExhibitorImportProgress,
  ExhibitorImportStatus,
  ExhibitorsCsvFileStatus,
} from "./helpers";

export const selectExhibitorsValidationResult = (state: State) =>
  state.exhibitorBulkUploadStatus.exhibitorsValidationResult;

export const selectBulkUploadStatus = (state: State) =>
  state.exhibitorBulkUploadStatus;

const initialState: ExhibitorImportStatus = {
  exhibitorImportProgress: ExhibitorImportProgress.FILE_UPLOAD,
  csvUploadProgress: ExhibitorCsvUploadProgress.TEMPLATE_DOWNLOAD,
  exhibitorsCsvFileStatus: "no-file-uploaded",
  exhibitorsValidationResult: null,
};

const bulkUploadSlice = createSlice({
  name: "bulkUploadStatus",
  initialState,
  reducers: {
    updateExhibitorsCsvFileStatus: (
      state,
      { payload }: { payload: ExhibitorsCsvFileStatus }
    ) => ({ ...state, exhibitorsCsvFileStatus: payload }),

    goToExhibitorCsvFileUpload: (state) => ({
      ...state,
      exhibitorImportProgress: ExhibitorImportProgress.FILE_UPLOAD,
      csvUploadProgress: ExhibitorCsvUploadProgress.CSV_UPLOAD,
    }),

    goToReviewAndSubmit: (state) => {
      return {
        ...state,
        exhibitorImportProgress: ExhibitorImportProgress.REVIEW,
      };
    },

    resetExhibitorsImportProgress: () => cloneDeep(initialState),

    updateExhibitorsValidationResult: (
      state,
      {
        payload: exhibitorsValidationResult,
      }: { payload: ExhibitorsValidationResult }
    ) => ({
      ...state,
      exhibitorsValidationResult: {
        ...state.exhibitorsValidationResult,
        ...exhibitorsValidationResult,
      },
    }),
  },
});

export const {
  updateExhibitorsCsvFileStatus,
  goToReviewAndSubmit,
  goToExhibitorCsvFileUpload,
  resetExhibitorsImportProgress,
  updateExhibitorsValidationResult,
} = bulkUploadSlice.actions;
export default bulkUploadSlice.reducer;
